var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8385 11.668H12.5052V9.16797H15.0052V7.5013H12.5052V5.0013H10.8385V7.5013H8.33854V9.16797H10.8385V11.668ZM6.67188 15.0013C6.21354 15.0013 5.82132 14.8382 5.49521 14.5121C5.16854 14.1855 5.00521 13.793 5.00521 13.3346V3.33464C5.00521 2.8763 5.16854 2.4838 5.49521 2.15714C5.82132 1.83102 6.21354 1.66797 6.67188 1.66797H16.6719C17.1302 1.66797 17.5227 1.83102 17.8494 2.15714C18.1755 2.4838 18.3385 2.8763 18.3385 3.33464V13.3346C18.3385 13.793 18.1755 14.1855 17.8494 14.5121C17.5227 14.8382 17.1302 15.0013 16.6719 15.0013H6.67188ZM6.67188 13.3346H16.6719V3.33464H6.67188V13.3346ZM3.33854 18.3346C2.88021 18.3346 2.48799 18.1716 2.16188 17.8455C1.83521 17.5188 1.67188 17.1263 1.67188 16.668V5.0013H3.33854V16.668H15.0052V18.3346H3.33854Z",
    fill: "#51B441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/addNew.94dd44576ef6639a0a6979044a4dd363.svg";
export { ForwardRef as ReactComponent };